import { GetUsersResponse } from '@inplay/models';
import { CountryProps } from '../../component/dropDownInput/dropDownInput.type';
import { OrganizationUnitChildItem } from '../../component/organizationUnitDropdown/organizationUnitDropdown.type';
import { DropdownOption } from '../../component/dropDownMenu/dropDownMenu.type';
import { VenuesViewKebabOptions } from './venuesView/venuesView.type';
import { OrgUnit } from '../../utils/helper.type';

export type UserManagementProps = {};

export enum UserType {
  ORGANIZATION_ADMIN = 'OrganizationAdmin',
  SUB_ORGANIZATION_ADMIN = 'SubOrganizationAdmin',
  VENUE_ADMIN = 'VenueAdmin',
  VENUE_MANAGER = 'VenueManager',
  VENUE_STAFF = 'VenueStaff',
  VENUE_BRANCH_LOGIN = 'VenueBranchLogin',
}

export type ActionButtonsVisibility = {
  isShowActivate?: boolean;
  isShowDeactivate?: boolean;
  isShowDelete?: boolean;
  isShowAdd?: boolean;
  isShowDownload?: boolean;
};

export const actionVisibility = {
  isShowActivate: true,
  isShowDeactivate: false,
};

export type UserFormValues = {
  userType: string;
  firstName: string;
  lastName: string;
  venue: string;
  email: string;
  mobile: string;
  venueBranch: string[];
  country: CountryProps;
};

export type AddUserProps = {
  isOpenAddUserModal: boolean;
  onCancel: () => void;
  handleCloseUserModal: () => void;
};

export type UserFilterProps = {
  isOpenUserModal: boolean;
  handleCloseUserModal: () => void;
};

export enum UserManagementHeaderKey {
  NAME_PHOTO = 'Name & Photo',
  STATUS = 'Status',
  USER_TYPE = 'User Type',
  VENUE_BRANCH = 'Venue Branch',
  EMAIL = 'Email',
  MOBILE = 'Mobile',
  ADDED_BY = 'Added By',
  SUB_ORGANISATION = 'Sub-Organisation',
  VENUE = 'Venue',
}

export enum UserKey {
  FIRST_NAME = 'firstName',
  STATUS = 'status',
  TYPE = 'type',
}

export enum OrganisationToggleEnum {
  VENUE_USERS = 'Venue Users',
  VENUES = 'Venues',
  ORGANISATION = 'Organisation',
}

export enum ActiveStaffOption {
  DEACTIVATE = 'Deactivate',
  EDIT = 'Edit',
  DELETE = 'Delete',
  GENERATE_NEW_PIN = 'Generate new PIN',
}

export enum KebabOption {
  ResendInvitation = 'Resend invitation',
  Delete = 'Delete',
  Edit = 'Edit',
  GenerateNewPin = 'Generate new Pin',
  Activate = 'Activate',
  InActivate = 'Deactivate',
  Download = 'Download',
}

export type OptionWithLoading<Kebabaction extends string = string> = {
  label: Kebabaction;
  loading: boolean;
  value: string;
};

export type TextInputProps = {
  placeholder: string;
  value: string;
  errorMessage?: string;
  fieldKey: string;
  handleChange: (key: string, value: string) => void;
  setFieldError: any;
  requiredMessage?: string;
};

export type EditOrgUnitProps = {
  setIsOpen: (value: boolean) => void;
  isOpen: boolean;
  editType?: VenuesViewKebabOptions; // Send undefined to get the UI where we get a venue branch dropdown
  data?: OrgUnit; // Send undefined to get the UI where we get a venue branch dropdown
};

export type venueBranchOptionType = {
  label: string;
  value: string;
  venueId: string;
  organizationId: string;
};

export type UserManagementTableHeaderProps<OptionKey extends string = string> =
  {
    allUsers: GetUsersResponse[];
    selectedOrganisationToggle: string;
    setSelectedOrganisationToggle: (
      selectedToggle: OrganisationToggleEnum,
    ) => void;
    handleAddActions: (action: OptionKey) => void;
    addMenuOptions: DropdownOption<OptionKey>[];
    searchQuery: string;
    handleOnChangeSearch: (value: string) => void;
    selectedCount: number;
    unitTranslationKey: string;
    handleClose?: () => void;
    handleActivate?: () => void;
    handleDeactivate?: () => void;
    handleDelete?: () => void;
    actionVisibility?: ActionButtonsVisibility;
    onSettingMenuSelect?: (label: string | undefined) => void;
    selectedLabel?: OrganizationUnitChildItem;
    handleSelect?: (selectedChildItem: OrganizationUnitChildItem) => void;
    showOrganizationToggle?: boolean;
  };

export type AddButtonWithDropdownProps<OptionKey extends string = string> = {
  addMenuOptions: DropdownOption<OptionKey>[];
  handleClick: (action: OptionKey) => void;
};

export type OrganizationFormValue = string | number;
export type OrganizationFormValues = Record<string, OrganizationFormValue>;
